export enum CellType {
  Transparent = 0,
  Stained = 1,
  BuddingTransparent = 2,
  BuddingStained = 3,
  BuddingSmall = 4,
  Brettanomyces = 5,
}
